import { jsx as _jsx } from "react/jsx-runtime";
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
import { forwardRef } from "react";
/**
 * This is a useful component in certain scenarios as an alternative to traditional labelling with `aria-label` or `aria-labelledby`.
 */
const VisuallyHidden = ({ children, ...visuallyHiddenProps }, forwardedRef) => (_jsx(VisuallyHiddenPrimitive.Root, { ...visuallyHiddenProps, ref: forwardedRef, children: children }));
export default forwardRef(VisuallyHidden);
//# sourceMappingURL=VisuallyHidden.js.map